import React from 'react';
import dataIncompleteIcon from 'assets/icons/incomplete.svg';
import Button from '../common/Button';
import {useTranslation} from 'react-i18next';
import {ContentModal, WarningIcon} from './styled';

type ModalTypes = {
  onClose: () => void;
};

function DuplicateGuestModal({onClose}: ModalTypes) {
  const {t} = useTranslation();
  return (
    <ContentModal className="duplicate-guest-modal">
      <WarningIcon src={dataIncompleteIcon} alt="Form with a red field" />
      <div className="duplicate-guest-modal__title">{t('duplicated_guest')}</div>
      <div className="duplicate-guest-modal__text">
        {t('there_is_already_a_registered')}
      </div>
      <div className="duplicate-guest-modal__text duplicate-guest-modal__text_secondary">
        {t('for_parents_and_children')}
      </div>

      <div className="duplicate-guest-modal__buttons">
        <Button onClick={onClose} label={t('ok')} width={270} />
      </div>
    </ContentModal>
  );
}

export {DuplicateGuestModal};
